// src/lib/stripePromise.js — shared lazy Stripe.js loader. One promise per
// page load; returns null when REACT_APP_STRIPE_PK is unset so callers can
// render their config-error state instead.
import { loadStripe } from '@stripe/stripe-js';

let stripePromise = null;
export const getStripePromise = () => {
    if (!stripePromise && process.env.REACT_APP_STRIPE_PK) {
        stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
    }
    return stripePromise;
};
